import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { observer } from "mobx-react";
import { PairingSelectDeviceComponent } from './pairing_selectdevice';
import { CPairingDevice, EDevicePairingState } from './devices/pairingdevice';
import { InitLocalization, Localize } from "shared/utils/localization";
import VRHTML from '@valve/steamvr';
import { PairingStore, EPairingState } from "./pairingstore";
import * as SVG from './ui/svg_library';

export function BottomButtons( props: React.Props< any > )
{
	return <div className="FlexColumn BottomRight HalfWidth">
		{ props.children }
	</div>;
}

export interface BottomButtonProps
{
	text?: string;
	onClick?: () => void;
	focus?: boolean;
}

export function BottomButton( props: BottomButtonProps )
{
	let sClassName = "ButtonControl";
	if ( props.focus )
	{
		sClassName += " Focus";
	}

	return <div className={ sClassName } onClick={ props.onClick }><span>{ props.text }</span></div>;
}

function ControllerBackground()
{
	return <div className="ControllerBackground">
		<div className="ViveTracker">{ SVG.PairingUIIcon_Tracker( false ) }</div>
		<div className="Knuckles">{ SVG.PairingUIIcon_Knuckles( false ) }</div>
		<div className="ViveWand">{ SVG.PairingUIIcon_Wand( false ) }</div>
		<div className="VRInkPilotEdition">{ SVG.PairingUIIcon_Wand( false ) }</div>
	</div>;
}

interface PairingState
{

	pairingDeviceInfo?: CPairingDevice;
}

@observer class PairingMain extends React.Component<{},PairingState>
{


	constructor( props: any )
	{
		super( props );

		PairingStore.init();

		this.state = {
			pairingDeviceInfo: null,
		};
	}

	public render(): JSX.Element
	{
		let content: JSX.Element;

		switch ( PairingStore.pairingState )
		{
			case EPairingState.Idle:
				content = null; // Window is hidden.
				break;

			case EPairingState.FetchingInitialDongleList:
				content = <div className="InitializingPage">
					<div className="Title Label">{ Localize( '#pairing_initializing_title' ) }</div>
					<div className="PageContent">
						<div className="Label">
							{ Localize( '#pairing_initializing_desc' ) }<br />
							<br />
							<span className="Highlight">{ Localize( '#pairing_initializing_instr' ) }</span>
						</div>
					</div>
					<BottomButtons>
						<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_cancel' ) } />
					</BottomButtons>
				</div>;
				break;

			case EPairingState.NoDonglesAvailable:
				content = <div>
					<ControllerBackground />
					<div className="Title Label">{ Localize( '#pairing_nofreedongles_title' ) }</div>
					<div className="PageContent">
						<div className="Label">
							{ Localize( '#pairing_nofreedongles_desc' ) }<br />
							<br />
							<span dangerouslySetInnerHTML={ { __html: Localize( '#pairing_nofreedongles_instr' ) } } />
						</div>
					</div>
					<BottomButtons>
						<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_cancel' ) } />
					</BottomButtons>
				</div>;
				break;

			case EPairingState.NoDonglesDetected:
				content = <div>
					<ControllerBackground />
					<div className="Title Label">{ Localize( '#pairing_nodongles_title' ) }</div>
					<div className="PageContent">
						<div className="Label">
							{ Localize( '#pairing_nodongles_desc' ) }<br />
							<br />
							<span className="Highlight">{ Localize( '#pairing_nodongles_instr' ) }</span>
						</div>
					</div>
					<div className="FlexColumn BottomRight HalfWidth">
					</div>
					<BottomButtons>
						<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_cancel' ) } />
					</BottomButtons>
				</div>;
				break;

			case EPairingState.PairingFailed:
				content = <div>
					<ControllerBackground />
					<div className="Title Label">{ Localize( '#pairing_start_failed_title' ) }</div>
					<div className="PageContent">
						<div className="Label">{ Localize( '#pairing_start_failed_desc' ) }</div>
					</div>
					<BottomButtons>
						<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_cancel' ) } />
					</BottomButtons>
				</div>;
				break;

			case EPairingState.UpdatingDongleListAfterPairing:
			case EPairingState.Success:
			case EPairingState.WaitingForDeviceToPair:
			case EPairingState.TimedOut:
				if ( PairingStore.pairingDevice != null )
					content = PairingStore.pairingDevice.render();
				else
					// Escape hatch: Something cleared our pairing device, probably got in a weird state. Don't explode.
					content = <PairingSelectDeviceComponent />;
				break;

			case EPairingState.DongleListReady:
				content = <PairingSelectDeviceComponent />;
				break;

			default:
				// This will never happen (famous last words), but we gotta show something.
				content = <div>
					<ControllerBackground />
					<div className="Title Label">Uh oh</div>
					<div className="PageContent">
						<div className="Label">Invalid pairing UI state.</div>
					</div>
					<BottomButtons>
						<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_cancel' ) } />
					</BottomButtons>
				</div>;
		}

		return ( <div className="FullPage">
			<div className="PairingWindow">
				{ content }
			</div>
		</div> );
	}
}

InitLocalization( ['lighthouse_web'], VRHTML?.GetSteamVRLanguage() )
.then( () => { ReactDOM.render( <PairingMain />, document.getElementById( 'root' ) ); } );
